import { DateTime } from "luxon";

export const formatTimestamp = (timestamp) => {
  if (!timestamp) return "N/A";

  const date = DateTime.fromSeconds(timestamp).toUTC();
  return date.toLocaleString(DateTime.DATE_MED);
};
